enum CERTIFICATE_TYPE {
    ENTERPRISE = '0',//企业证书
    SYSTEM_STUDY = '1',// 系统学习证书
    CUSTOM_STUDY = '2', // 自定义学习证书
}
/**
 * @desc 证书展示板式类型
*/
enum CERTIFICATE_FORMAT {
    VERTICAL = 1, // 垂直竖版
    HORIZONTAL // 水平横版
}

enum CERTIFICATE_SOURCE {
    SYSTEM_TEMPLATE = 1,
    USER_TEMPLATE,
    ENTERPRISE
}
enum CERTIFICATE_SOURCE_TYPE {
    TEMPLATE = 1,
    CUSTOM
}
// 证书所属来源类型
enum CERTIFICATE_SOURCE_BELONG_TYPE {
    COURSE, // 课程
    PROGRAM, // 学习项目
}
interface IQRCodeOptions {
    text: string,
    width?: number,
    height?: number,
    colorDark?: string,
    colorLight?: string,
    correctLevel?: number
}
interface IQrProps {
    id: string;
    className?: string;
    codeOptions: IQRCodeOptions;
}
interface ICertificateDisplayConfig {
    isShowValidityStartTime?: boolean;
    isShowValidityEndTime?: boolean;
    isShowCertificateIssueTime?: boolean;
    isShowCertificateQRCode?: boolean;
    isShowCourseName?: boolean;
    isShowSourceName?: boolean;
    isShowTraineesSubName?: boolean;
    isShowLecturer?: boolean;
    isAllowEditor?: boolean;
    setUpInfo?: ICertificateSetUpInfo;
}
interface ICertificateSetUpInfo {
    certificateIssueTime: string;
    certificateEffective: string;
    certificateEndTime: string;
    validPeriodTime: string;
    QRCodeUrl: string;
    lecturerName?: string;
    lecturerSubName?: string;
    certificateIsPermanent?: boolean;
}
enum CERTIFICATE_IMG_TYPE {
    IMG_TYPE, // 图片类型 png, svg等
    CUSTOM, // 自定义类型-需要传JSX.Element
}
interface ICertificateCourseInfo {
    courseName: string;
}
interface IWatermarkConfig {
    isShow?: boolean;
    viewType: 0 | 1;// 展示类型 0默认，1自定义
    watermarkImg: string;// 水印图片
}
interface ITrophyInfoConfig {
    isShow: boolean;
    viewType: 0 | 1;// 展示类型 0默认，1自定义
    isEnterprise?: boolean;// 是否为企业用户-默认类型展示判断依据
    cls?: string;// 传入样式
    trophyElement?: string | JSX.Element;// 水印图片
}
interface ICertificateThemeInfo {
    certificateId?: string;
    watermarkConfig?: IWatermarkConfig; // 水印配置
    trophyInfoConfig?: ITrophyInfoConfig; // 奖杯配置信息
    certificateImg: string | JSX.Element; // 背景展示图片
    displayStyle?: CERTIFICATE_FORMAT; // 证书展示板式类型
    themeType?: CERTIFICATE_TYPE; // 证书类型
    themeStyleType?: string;
    certificateType?: CERTIFICATE_IMG_TYPE; // 证书背景展示类型
    certificateName?: string; // 证书标题
    traineesName?: string | JSX.Element; // 学员名称
    traineesSubName?: string | JSX.Element; // 学员名称副标题--默认未员工工号
    certificateContentStyle?: React.CSSProperties; // 证书内容样式
    certificateText: string; // 证书正文
    enterpriseInfo: ICertificateEnterpriseInfo; // 证书关联企业设置信息
    courseInfo?: ICertificateCourseInfo; // 证书关联课程信息
    certificateDisplayConfig: ICertificateDisplayConfig; // 证书展示配置信息
    isCustomWidth?: boolean;
    certificateWidth?: number;
    certificateHeight?: number;
    sourceData?: any;
    onConfigChange?: (key: string, val: any) => void;
}

interface ICertificateEnterpriseInfo {
    logo: string;
    logoType?: CERTIFICATE_IMG_TYPE; // 企业log类型
    issuingUnitName?: string; // 颁发单位名称
}
export {
    IQrProps,
    CERTIFICATE_FORMAT,
    CERTIFICATE_TYPE,
    CERTIFICATE_SOURCE_BELONG_TYPE,
    ICertificateCourseInfo,
    ICertificateThemeInfo,
    CERTIFICATE_SOURCE,
    CERTIFICATE_SOURCE_TYPE,
    ICertificateEnterpriseInfo,
    CERTIFICATE_IMG_TYPE,
    ICertificateSetUpInfo,
    ICertificateDisplayConfig
}
